import React from "react";
import { Component } from "react";
import styled from "styled-components";
import nota from "./../Global/nota.guidelines.json";

import Type from "./../Global/Typography.js";
import NanoFlex from "./../Global/NanoFlex";

import { ReactComponent as Eye } from "./../Global/Icons/eye.svg";
import { ReactComponent as EyeClosed } from "./../Global/Icons/eyeClosed.svg";

const StyledInput = styled.div`
  text-align: left;
  margin: 20px auto;
  position: relative;

  .title {
    color: ${(props) => (props.error ? nota.color.main.mTwo : nota.color.main.defaultTwo)};
    margin: 8px 0;
  }
  .inputWrapper {
    font-family: ${nota.font};
  }
  input {
    border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
    padding: 10px;
    width: 100%;
    font-size: 12px;
    color: ${nota.color.neutral.NeuOne};
    font-family: ${nota.font};
    &::placeholder {
      font-family: ${nota.font};
      color: ${nota.color.neutral.NeuTwo};
    }
    //&:focus {
    //  border: 1px solid ${nota.color.neutral.NeuOne};
    //}
  }
  .eye {
    position: absolute;
    bottom: 0px;
    right: 0px;
    height: 36px;
    width: 40px;
    user-select: none;
    svg {
      cursor: pointer;
    }
  }
`;

class Input extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEye: false,
    };

    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.inputRef.current.value = this.props.defaultValue;
    }
  }

  toggleEye = () => {
    this.setState({ showEye: !this.state.showEye });
  };

  render() {
    return (
      <StyledInput className="inputContainer" error={this.props.error}>
        {this.props.title && <Type.h5 className="title">{this.props.title}</Type.h5>}

        <NanoFlex className="inputWrapper">
          <input
            ref={this.inputRef}
            type={this.props.eye ? (this.state.showEye ? "text" : "password") : "text"}
            placeholder={this.props.placeholder}
            {...(!this.props.forceValue ? { defaultValue: this.props.defaultValue } : null)}
            {...(this.props.forceValue ? { value: this.props.defaultValue } : null)}
            onChange={(e) => {
              if (this.props.onChangeAction) {
                this.props.onChangeAction(e.target.value);
              }
            }}
            onKeyPress={(e) => {
              if (this.props.onKeyPress) {
                this.props.onKeyPress(e);
              }
            }}
            onKeyDown={(e) => {
              if (this.props.onKeyDown) {
                return this.props.onKeyDown(e);
              }
            }}
            name={this.props.name ?? Math.random().toString(36).substring(7)}
            {...(!this.props.enableAutoComplete ? { autoComplete: /chrome/.test(navigator.userAgent.toLowerCase()) ? "new-password" : "off" } : null)}
          />
          {this.props.eye && this.state.showEye && (
            <NanoFlex className="eye" onClick={this.toggleEye}>
              <Eye />
            </NanoFlex>
          )}
          {this.props.eye && !this.state.showEye && (
            <NanoFlex className="eye" onClick={this.toggleEye}>
              <EyeClosed />
            </NanoFlex>
          )}
        </NanoFlex>

        {this.props.menssage && <Type.h6 className="menssage">{this.props.menssage}</Type.h6>}
      </StyledInput>
    );
  }
}

// Set default props
Input.defaultProps = {
  id: 0,
  type: "text",
  title: "Title",
  defaultValue: "",
  placeholder: "placeholder",
  menssage: null,
  eye: false,
  error: false,
};

export default Input;

// --- // Documentation // --- //
/*
import Input from './../Nano/Input.js';

<Input
    id={0}
    title='Username'
    value={state or prop Value}
    placeholder='Username'
    error={false}
    onChangeAction={() => console.log('onChangeAction')}
/>

<Input
    id={0}
    type={this.state.showPassword ? 'text' : 'password'}
    title='Password'
    value={state or prop Value}
    placeholder=''
    eye={true}
    showPassword={this.state.showPassword}
    error={this.state.error !== null}
    onClickEyeToggle={() => this.setState({ showPassword: !this.state.showPassword })}
    onChangeAction={(currentValue, id, title, type) => this.passwordChange(currentValue)}
/>
*/
